/**
 * IMPORT DIRECTIVES FOR APP
 * Path being matched: @/utils/directives/<any_folder>/index.js
 */

const requireDirectives = require.context('@/utils/directives', true, /.*\/index.js$/)
const directivesUnparsed = []
const directives = []

requireDirectives.keys().forEach(key => {
    directivesUnparsed.push(requireDirectives(key))
})

directivesUnparsed.forEach(el => {
  Object.keys(el).forEach(key => {
    directives.push(el[key])
  })
})

export default directives